import React from 'react';
import LandingPage from '../components/home/LandingPage';

const Home = () => {
  return <LandingPage />;
};

export default Home;